import { OffersClickoutGuard as e } from "../offers-clickout/index.js";
import { Component as t, Suspense as n } from "react";
import { jsx as r } from "react/jsx-runtime";
import { useTranslation as i } from "react-i18next";
import a from "@cx-modules/offers-list";
//#region page-template/OffersList/OffersList.tsx
var o = class extends t {
	state = { hasError: !1 };
	static getDerivedStateFromError() {
		return { hasError: !0 };
	}
	componentDidCatch(e) {
		this.props.onError?.(e);
	}
	render() {
		return this.state.hasError ? null : this.props.children;
	}
}, s = ({ onError: t, ...s }) => {
	let { i18n: c } = i(), l = ["IT"].includes(s.repub) ? 2 : Infinity, u = {
		...s,
		filtersThreshold: l,
		i18n: c
	};
	return /* @__PURE__ */ r(o, {
		onError: t,
		children: /* @__PURE__ */ r(n, {
			fallback: null,
			children: /* @__PURE__ */ r("div", {
				"data-country-code": s.countryCode,
				"data-geo-subdivision-code": s.geoSubdivisionCode,
				"data-lang": c.language,
				"data-repub": s.repub,
				"data-subdivision-code": s.subdivisionCode,
				children: /* @__PURE__ */ r(e, {
					componentName: "OffersList",
					values: u,
					children: /* @__PURE__ */ r(a, { ...u })
				})
			})
		})
	});
};
//#endregion
export { s as OffersList };
